import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=7ba85760&scoped=true"
import script from "./Inform.vue?vue&type=script&lang=js"
export * from "./Inform.vue?vue&type=script&lang=js"
import style0 from "./Inform.vue?vue&type=style&index=0&id=7ba85760&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba85760",
  null
  
)

export default component.exports